import React from 'react';
import { DeviceUI } from './DeviceUI';
import { Tab } from 'semantic-ui-react';
import { FieldUI } from './FieldUI';
import { DivisionUI } from './DivisionUI';
import { OrdinaryUI } from './OrdinaryUI';
import { General } from './General';
import { Device } from '../logic/Device';
import { apiConformDevice, apiGetRandomDesign, ChargePermutations } from '../logic/HeraldryAPI';
import { deepCopy } from '../logic/utils';

import 'semantic-ui-css/semantic.min.css';
import '../ws/worldspinner.css';
import './HeraldryWidget.css';

interface Props {
}
interface State {
    device: Device | undefined,
    colors: string,
    options: ChargePermutations,
}

export class HeraldryWidget extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            device: undefined,
            colors: "Historical",
            options: {
                field: [0],
                division: [0],
                ordinary: [0],
            },
        };
    }

    public render() {
        return <div>
            <div id="#3" style={{height: "10px"}}/>
            <div id="heraldry-widget">
                <DeviceUI device={this.state.device}
                    setOptions={(options: ChargePermutations) => this.setOptions(options)} />
                {this.renderTabs()}
            </div>
        </div>;
    }

    private renderTabs() {

        const panes = [
            {
                menuItem: 'General',
                render: () => <Tab.Pane attached={true}>
                    <General
                        device={this.state.device} changeDevice={(device: Device | undefined) => this.changeDevice(device)}
                        colors={this.state.colors} changeColors={(colors: string) => this.setState({ colors })}
                    />
                </Tab.Pane>,
            },
            {
                menuItem: 'Field',
                render: () => <Tab.Pane attached={true}>
                    <FieldUI device={this.state.device} changeDevice={(device: Device | undefined) => this.changeDevice(device)}
                        options={this.state.options}
                        historical={this.state.colors === "Historical"} />
                </Tab.Pane>,
            },
            {
                menuItem: 'Division',
                render: () => <Tab.Pane attached={true}>
                    <DivisionUI device={this.state.device} changeDevice={(device: Device | undefined) => this.changeDevice(device)}
                        options={this.state.options}
                        historical={this.state.colors === "Historical"} />
                </Tab.Pane>,
            },
            {
                menuItem: 'Ordinary',
                render: () => <Tab.Pane attached={true}>
                    <OrdinaryUI device={this.state.device} changeDevice={(device: Device | undefined) => this.changeDevice(device)}
                        options={this.state.options}
                        historical={this.state.colors === "Historical"} />
                </Tab.Pane>,
            },
        ];

        return < Tab menu={{ secondary: true, pointing: true }} panes={panes} />;
    }

    private setOptions(options: ChargePermutations) {
        // console.log("HeraldryWidget.setOptions: options=", options);
        const device = deepCopy(this.state.device) as Device;
        apiConformDevice(device, options);
        this.setState({ device, options });
    }

    public componentDidMount() {
        this.changeDevice (undefined);
        // apiGetOptions(this.state.device);
    }

    private async changeDevice(device: Device | undefined) {
        if (!device) {
            device = await this.randomDevice();
            if (!device) {
                device = await this.randomDevice();
                throw new Error("Cannot get device");
            }
        }
        this.setState({ device });
    }

    private async randomDevice(): Promise<Device> {
        console.log("randomDevice...");
        // this.setState({ respinning: true });
        const device = await apiGetRandomDesign();
        console.log("randomDevice result: ", device);
        return device;
        // this.props.changeDevice(design);
        // this.setState({ tick: this.state.tick + 1 });
        // this.setState({ respinning: false });
    }

}
